// frontend/src/config/api.js
// Конфигурация API для разных окружений

const getApiConfig = () => {
    // Определяем окружение по приоритету:
    // 1. Переменная REACT_APP_ENV
    // 2. NODE_ENV
    // 3. hostname
    const isDevelopment = process.env.REACT_APP_ENV === 'development' ||
        (process.env.REACT_APP_ENV !== 'production' &&
            (process.env.NODE_ENV === 'development' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1'));

    if (isDevelopment) {
        return {
            baseUrl: 'http://localhost:8000/api',
            publicUrl: 'http://127.0.0.1:8002/api/v1', // Laravel API для локальной разработки
            adminUrl: 'http://localhost:8000/api/admin'
        };
    } else {
        // Для продакшена используем переменную окружения или дефолтный URL
        const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://ignite-web.com/api';
        return {
            baseUrl: baseUrl,
            publicUrl: `${baseUrl}/public`,
            adminUrl: `${baseUrl}/admin`
        };
    }
};

export const API_CONFIG = getApiConfig();

// Удобные функции для API вызовов
export const getPublicApiUrl = (endpoint) => {
    // Для локальной разработки используем Laravel API напрямую
    const isDevelopment = process.env.REACT_APP_ENV === 'development' ||
        (process.env.REACT_APP_ENV !== 'production' &&
            (process.env.NODE_ENV === 'development' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1'));

    if (isDevelopment) {
        return `${API_CONFIG.publicUrl}/${endpoint}`;
    }
    // В продакшене используем текущий домен + Laravel API
    // Принудительно используем HTTPS для продакшена
    const protocol = window.location.hostname === 'localhost' ? 'http' : 'https';
    return `${protocol}://${window.location.host}/api/v1/${endpoint}`;
};

// Функция для чата - всегда использует старый PHP API
export const getChatApiUrl = (endpoint) => {
    const isDevelopment = process.env.REACT_APP_ENV === 'development' ||
        (process.env.REACT_APP_ENV !== 'production' &&
            (process.env.NODE_ENV === 'development' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1'));

    if (isDevelopment) {
        return `http://localhost:8000/api/public/${endpoint}`;
    }
    return `${API_CONFIG.baseUrl}/public/${endpoint}`;
};

// Функция для Special Offer - всегда использует Laravel API
export const getSpecialOfferApiUrl = (endpoint) => {
    const isDevelopment = process.env.REACT_APP_ENV === 'development' ||
        (process.env.REACT_APP_ENV !== 'production' &&
            (process.env.NODE_ENV === 'development' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1'));

    if (isDevelopment) {
        return `http://127.0.0.1:8002/api/v1/${endpoint}`;
    }
    // В продакшене используем основной домен через Nginx прокси
    // Nginx проксирует /api/v1/ на Laravel API
    const protocol = window.location.hostname === 'localhost' ? 'http' : 'https';
    return `${protocol}://${window.location.hostname}/api/v1/${endpoint}`;
};

export const getAdminApiUrl = (endpoint) => `${API_CONFIG.adminUrl}/${endpoint}`;
export const getApiUrl = (endpoint) => `${API_CONFIG.baseUrl}/${endpoint}`;

// Функция для админ панели - работает и локально, и на продакшене
export const getAdminPanelApiUrl = (endpoint) => {
    const isDevelopment = process.env.REACT_APP_ENV === 'development' ||
        (process.env.REACT_APP_ENV !== 'production' &&
            (process.env.NODE_ENV === 'development' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1'));

    if (isDevelopment) {
        // Локально используем локальный API
        return `${API_CONFIG.adminUrl}/${endpoint}`;
    } else {
        // На продакшене используем текущий домен + админ API
        // Принудительно используем HTTPS для продакшена
        const protocol = window.location.hostname === 'localhost' ? 'http' : 'https';
        return `${protocol}://${window.location.host}/api/admin/${endpoint}`;
    }
};

// Функция для публичного API в админ панели
export const getAdminPanelPublicApiUrl = (endpoint) => {
    const isDevelopment = process.env.REACT_APP_ENV === 'development' ||
        (process.env.REACT_APP_ENV !== 'production' &&
            (process.env.NODE_ENV === 'development' ||
                window.location.hostname === 'localhost' ||
                window.location.hostname === '127.0.0.1'));

    if (isDevelopment) {
        // Локально используем локальный API
        return `${API_CONFIG.baseUrl}/public/${endpoint}`;
    } else {
        // На продакшене используем текущий домен + публичный API
        // Принудительно используем HTTPS для продакшена
        const protocol = window.location.hostname === 'localhost' ? 'http' : 'https';
        return `${protocol}://${window.location.host}/api/public/${endpoint}`;
    }
};

export default API_CONFIG;